import PropTypes from "prop-types";
// images
import LoadingGhostImg from "../../img/loading-ghost.svg";
import LoadingSpinImg from "../../img/loading-spin.svg";

const MamaUser = ["vichanc", "wimols"];

DashboardLoading.propTypes = {
  isLoading: PropTypes.bool,
  isHide: PropTypes.bool,
  username: PropTypes.string,
};

export default function DashboardLoading({ isLoading, isHide, username }) {
  return (
    <div
      className="loading"
      style={{
        opacity: isLoading ? 1 : 0,
        display: isHide ? "none" : "block",
      }}
    >
      <div className="con">
        {!MamaUser.find(
          (m) => m.toLowerCase() === (username || "").toLowerCase()
        ) ? (
          <img alt="loading-anime" src={LoadingGhostImg} />
        ) : (
          <img alt="loading-anime" src={LoadingSpinImg} />
        )}
      </div>
    </div>
  );
}
